import React from "react";
import { Form, InputGroup, Button } from "react-bootstrap";
import { Eye, EyeSlash } from "react-bootstrap-icons";

interface PasswordInputGroupProps {
  label: string;
  value: string;
  name: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  showPassword: boolean;
  toggleShow: () => void;
  placeholder: string;
  isInvalid?: boolean;
  feedback?: string;
  helpText?: string;
}

export const PasswordInputGroup: React.FC<PasswordInputGroupProps> = ({
  label,
  value,
  name,
  onChange,
  showPassword,
  toggleShow,
  placeholder,
  isInvalid,
  feedback,
  helpText,
}) => {
  return (
    <Form.Group className="mb-3">
      <Form.Label>{label}</Form.Label>
      <InputGroup>
        <Form.Control
          type={showPassword ? "text" : "password"}
          placeholder={placeholder}
          className="rounded-5"
          style={{ position: "relative" }}
          value={value}
          name={name}
          onChange={onChange}
          isInvalid={isInvalid}
        />
        <Button
          variant="secondary"
          type="button"
          style={{position: "absolute", zIndex: 10, color: "#6c757d", backgroundColor: "#fff", height: 36, width: 36, top: 1, right: 1, border: "none"}}
          onClick={toggleShow}
          className="rounded-end-5"
        >
          {showPassword ? <EyeSlash style={{ marginTop: "-4px" }} /> : <Eye style={{ marginTop: "-4px" }} />}
        </Button>
        {isInvalid && <Form.Control.Feedback type="invalid">{feedback}</Form.Control.Feedback>}
      </InputGroup>
      {helpText && <Form.Text className="text-muted">{helpText}</Form.Text>}
    </Form.Group>
  );
};